import { inject, Injectable } from '@angular/core';
import { Observable, map, of } from 'rxjs';

import { BaseService } from './base.service';
import { NotificationService } from '../notification.service';
import { Search, SearchPage } from '../../models';

@Injectable({
  providedIn: 'root',
})
export abstract class BaseEditService<T, TEdit> extends BaseService {
  protected readonly notificationService = inject(NotificationService);

  name: string;

  protected constructor(baseRoute: string, name: string) {
    super(baseRoute);

    this.name = name;
  }

  search(model?: Search): Observable<T[]> {
    return this.searchPage(model).pipe(map((searchPage: SearchPage<T>) => searchPage.results));
  }

  searchPage(model?: Search): Observable<SearchPage<T>> {
    if (!model) {
      model = {};
    }
    model.search = model.search?.trim();

    if (
      !model.search &&
      !model.id &&
      !model.id2 &&
      !model.fromDate &&
      !model.toDate &&
      (model.allowBlankSearch === false || (model.includeAll && !model.allowIncludeAllBlankSearch))
    ) {
      this.notificationService.fail($localize`Cannot search entire data without filters`);
      return of({ results: [], count: 0 } as SearchPage<T>);
    }

    return this.httpService.post<SearchPage<T>>(`${this.apiUrl}/Search`, model);
  }

  create(parentId?: string, parentId2?: string): Observable<TEdit> {
    return of({} as TEdit);
  }

  edit(id: string): Observable<TEdit> {
    return this.httpService.get<TEdit>(`${this.apiUrl}/${id}`);
  }

  save(model: TEdit): Observable<string> {
    return this.httpService.post<string>(this.apiUrl, model);
  }

  delete(id: string): Observable<any> {
    return this.httpService.delete(`${this.apiUrl}/${id}`);
  }
}
